import { ViewChild, Component, OnInit, OnChanges, SimpleChanges, DoCheck } from '@angular/core';
import { MultiSourceMultiValueWidget } from "../../base/MultiSourceMultiValueWidget";
import { SharedPoint, SharedSeries } from "src/app/models/dashboard";

import * as Highcharts from "highcharts/highstock";
import theme from 'highcharts/themes/brand-dark';
theme(Highcharts);

@Component({
  selector: "app-size-comparison-widget",
  templateUrl: "./size-comparison-widget.component.html",
  styleUrls: ["./size-comparison-widget.component.css"],
})
export class SizeComparisonWidgetComponent extends MultiSourceMultiValueWidget implements OnChanges, DoCheck {
  Highcharts = Highcharts;
  chart: Highcharts.Chart;
  chartCallback: Highcharts.ChartCallbackFunction;
  chartOptions?: Highcharts.Options;

  private colours: string[];

  offset: number;
  public c: any;
  showValue: boolean;

  liveDataOnly(): boolean {
    return (<any>this.widget).period == null || (<any>this.widget).period == "";
  }

  override eventTypes: string[]; 
  override timeSeriesEvent(type: string, uri: string): void {
    
  }

  override widgetDataLoadComplete(): void {
      
  }

  widgetBeforeInit() {}

  widgetAfterInit() {
    // get the offset from UTC to Local in milliseconds
    this.offset = -(new Date().getTimezoneOffset() * 60 * 1000);
    var series = [];
    this.showValue = false;
    this.c = <any>this.config;
    
    const widgetType = this.c.type;
    var currentTime = new Date();

    this.colours = [
      '#2f7ed8', '#8bbc21', '#910000', '#1aadce',
      '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a',
      "#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9",
      "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"
    ];

    for (var i in this.config.timeSeriesList) {
      var ts = <any>this.config.timeSeriesList[i];
      if (ts.colour == null){
        ts.colour = this.colours[i];
      }
      let markerState = false;
      if(ts.showMarker){
        markerState = ts.showMarker == null ? true : ts.showMarker;
      }
      //if the lineWidth is 0, marker will be shown
      if(ts.size==0){
        markerState = true;  
      }
    }

    var c = <any>this.config;
    var currentTime = new Date();
    var minTime = new Date(c.from).getTime();
    var maxTime = new Date(c.to).getTime();
    if (c.period == null || c.period == ''){
      minTime = new Date(this.dashboard.from).getTime();
      maxTime = new Date(this.dashboard.to).getTime();
    }

    this.chartOptions = ({
      chart: {
        backgroundColor: "transparent",
        type: 'pie',
        height:'90%'
      },
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      time: {
        timezoneOffset: new Date().getTimezoneOffset()
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
            dataLabels: {
                enabled: (<any>this.widget).showLegend,
                format: '<b>{point.name}</b>: {point.percentage:.1f} %'
            }
        }
      },
      tooltip: {
        shared: true,
        pointFormat: '{point.name}: <b>{point.percentage:.1f}%</b>'
      },
      series: [{
        name: this.c.name,
        colorByPoint: true
      } as Highcharts.SeriesOptionsType],
    });

    this.chartCallback = chart => {
      this.chart = chart;
    }
  }

  refresh() {
    this.ngOnInit();
  }

  widgetDataLoadTimeout(){
    
  }

  widgetLiveDataLoaded(s: any) {
    
    if (this.chart && this.chart.series) {
      if (s != null && s.uri != null){
        var item = <any>this.config.timeSeriesList.find(i => i.uri == s?.uri);
        //  var item = <any>this.config.timeSeriesList[s.index];
        item.uri = s.uri;
        item.index = s.index;
        item.value = s.point.value;

        // find chart series reference related to the data loaded
        var cseries = this.chart.series[0];
        
        var data: any[] = [];
        for (let i of this.config.timeSeriesList as any[]){
          data.push({uri: i.uri, name: i.name == null ? i.uri : i.name, y: i.value });
        }
        
        if (cseries) {
          cseries.setData(data);
        }
      }
    }
  }

  widgetDataLoaded(s: SharedSeries) {
    if (this.chart && this.chart.series) {
      var point : any;
      if ((<any>this.widget).display == "Average"){
        const sum = s.values.reduce((a, b) => a + b.value, 0);
        const avg = (sum / s.values.length) || 0;
        point = {uri:s.uri, value:avg} as SharedPoint;
      }
      else if ((<any>this.widget).display == "Maximum"){
        point = s.values.sort((a,b)=>b.value-a.value)[0];
      }
      else if ((<any>this.widget).display == "Minimum"){
        var sorted = s.values.sort((a,b)=>b.value-a.value);
        point = sorted[sorted.length-1];
      }
      else if ((<any>this.widget).display == "Change"){
        var first = s.values[0].value;
        var last = s.values[s.values.length-1].value;
        point = {uri:s.uri, value:(last-first)} as SharedPoint;
      }
      else if (s.values.length > 0) /* assume latest */ {
        point = s.values[s.values.length-1];
      }else{
        point = {uri:s.uri, value: 0} as SharedPoint;
      }

      //var item = <any>this.config.timeSeriesList.find(i => i.uri == s?.uri);
      var item = <any>this.config.timeSeriesList[0];
      item.uri = s.uri;
      item.index = s.index;
      item.value = point.value;

      // find chart series reference related to the data loaded
      var cseries = this.chart.series[s.index];
      // we should have 1 series - we need to add the latest point to each.
      //var value = 5;
      

      var data: any[] = [];
      for (let i of this.config.timeSeriesList as any[]){
        data.push({uri: i.uri, name: i.name == null ? i.uri : i.name, y: i.value });
      }
      
      if (cseries) {
        cseries.setData(data);
      }
    }

  }

 
  widgetDataAdded(s: SharedPoint) {
  
  }

  ngDoCheck() {

  }

  ngOnChanges(changes: SimpleChanges) {
  }

}
